import { render } from "./ABoutUs_Sekretariati.vue?vue&type=template&id=3fb0449c&scoped=true"
import script from "./ABoutUs_Sekretariati.vue?vue&type=script&lang=js"
export * from "./ABoutUs_Sekretariati.vue?vue&type=script&lang=js"

import "./ABoutUs_Sekretariati.vue?vue&type=style&index=0&id=3fb0449c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb0449c"]])

export default __exports__